import { useOrganisations, type Organisation } from '@/hooks/use-organisations'
import {
  RichTextMarkdownArtifactCanvas,
  useMarkdownArtifactDraft,
} from '@/components/artifact/rich-text-markdown-artifact-canvas'
import { markdownFieldLengthError } from '@/lib/rich-text-visible-char-count'

interface OrganisationAboutCanvasProps {
  slug: string
  organisation: Organisation
  onClose: () => void
  onSaved?: (updated: Organisation) => void
}

export function OrganisationAboutCanvas({
  slug,
  organisation,
  onClose,
  onSaved,
}: OrganisationAboutCanvasProps) {
  const { updateOrganisation, isUpdating, updateError } = useOrganisations()
  const orgKey = organisation.id ?? slug
  const draft = useMarkdownArtifactDraft(organisation.description ?? '', orgKey)

  const handleSave = () => {
    const aboutLengthErr = markdownFieldLengthError(draft.value, 'About')
    if (aboutLengthErr) {
      draft.setValidationError(aboutLengthErr)
      return
    }

    draft.setValidationError(null)

    updateOrganisation(
      {
        slug,
        data: { description: draft.value.trim() },
      },
      {
        onSuccess: (updated) => {
          onSaved?.(updated)
          onClose()
        },
      },
    )
  }

  return (
    <RichTextMarkdownArtifactCanvas
      id="artifact-org-about"
      value={draft.value}
      onChange={draft.onChange}
      charCount={draft.charCount}
      onCharCountChange={draft.onCharCountChange}
      validationError={draft.validationError}
      serverError={updateError?.message}
      onClose={onClose}
      onSave={handleSave}
      isDirty={draft.isDirty}
      isSaving={isUpdating}
    />
  )
}
